import { openTimeStreamProject } from '../actions';
import type { OutlookSpaceId } from 'owa-timestream-types';
import getProjectId from './getProjectId';

export default function openTimeStreamProjectFromRoute(
    tenant: string | null | undefined,
    mailbox: string | null | undefined,
    outlookSpaceId: OutlookSpaceId
) {
    const projectId = getProjectId(tenant, mailbox, outlookSpaceId);
    openTimeStreamProject(projectId);
}
